import { lazy } from 'react';

const Dashboard = lazy(() => import('../pages/dashboard'));
const DailyCampaigns = lazy(() => import('../pages/campaigns/daily-campaigns'));
const YearlyCampaigns = lazy(
  () => import('../pages/campaigns/yearly-campaigns')
);
const CouponsAndBankOffers = lazy(() => import('../pages/coupons'));
const Receivables = lazy(() => import('../pages/receivables'));
const Segment = lazy(() => import('../pages/segment'));
const Sku = lazy(() => import('../pages/sku'));
const Experiments = lazy(() => import('../pages/experiments'));
const Reports = lazy(() => import('../pages/reports'));
const ASN = lazy(() => import('../pages/asn'));
const PoSummary = lazy(() => import('../pages/po-management/po-summary'));
const PoSummaryId = lazy(() => import('../pages/po-management/po-summary/id'));
const BulkPoCreation = lazy(
  () => import('../pages/po-management/bulk-po-creation')
);
const BulkJobs = lazy(() => import('../pages/po-management/bulk-jobs'));
const Login = lazy(() => import('../auth/Login'));

const ForgotPassword = lazy(() => import('../auth/ForgotPassword'));
const ResetPassword = lazy(() => import('../auth/ResetPassword'));
const VerifyUser = lazy(() => import('../auth/VerifyUser'));
const SignUp = lazy(() => import('../auth/Signup'));
const UserManagement = lazy(() => import('../pages/user-management'));
const PricingSummary = lazy(() => import('../pages/pricing-summary'));
const UploadPricing = lazy(() => import('../pages/upload-pricing'));
const Approvals = lazy(() => import('../pages/approvals'));
const BulkReports = lazy(() => import('../pages/po-management/bulk-reports'));

const LivePricing = lazy(() => import('../pages/pricing/screens/LivePricing'));
const SuggestedPricing = lazy(
  () => import('../pages/pricing/screens/SkuSuggestion')
);
const BundleSuggestedPricing = lazy(
  () => import('../pages/pricing/screens/BundleSuggestion')
);

const BundleLivePricing = lazy(
  () => import('../pages/pricing/screens/BundleLivePricing')
);

const CBPSuggestions = lazy(
  () => import('../pages/pricing/screens/CBPSuggestions')
);

const RejectedBatches = lazy(
  () => import('../pages/pricing/screens/RejectedBatches')
);

const POApproval = lazy(() => import('../pages/po-approval'));

const HistoricalPricing = lazy(
  () => import('../pages/pricing/screens/HistoricalPricing')
);

const ReturnPOAck = lazy(() => import('../pages/po-return'));
const CampaignSuggestions = lazy(
  () => import('../pages/pricing/screens/CampaignSuggestions')
);

export const ComponentsMap = {
  SignUp,
  VerifyUser,
  ResetPassword,
  ForgotPassword,
  Login,
  Dashboard,
  DailyCampaigns,
  YearlyCampaigns,
  CouponsAndBankOffers,
  Receivables,
  Segment,
  Sku,
  Experiments,
  Reports,
  ASN,
  PoSummary,
  PoSummaryId,
  BulkPoCreation,
  BulkJobs,
  BulkReports,
  UserManagement,
  PricingSummary,
  UploadPricing,
  Approvals,
  LivePricing,
  SuggestedPricing,
  BundleSuggestedPricing,
  BundleLivePricing,
  CBPSuggestions,
  RejectedBatches,
  POApproval,
  HistoricalPricing,
  ReturnPOAck,
  CampaignSuggestions,
};
